// src/theme.js
import { createTheme } from '@mui/material/styles';

// VentES BUY - Professional E-commerce Theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Professional Blue - trustworthy and modern
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#ff6f00', // Vibrant Orange - call-to-action
      light: '#ffa040',
      dark: '#c43e00',
    },
    background: {
      default: '#f5f5f5', // Light gray background
      paper: '#ffffff',
    },
    text: {
      primary: '#212121', // Dark gray (easier on eyes than pure black)
      secondary: '#757575', // Medium gray
    },
    success: {
      main: '#4caf50',
    },
    error: {
      main: '#f44336',
    },
  },
  typography: {
    fontFamily: [
      '"Roboto"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
    button: {
      textTransform: 'none', // More modern, less shouty
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8, // Slightly rounded for modern feel
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
          },
        },
      },
    },
  },
});

export default theme;

